<template>
  <div class="search">
    <!--1.头部-->
    <header-frame></header-frame>

    <div class="content">
      <h1>搜索</h1>
      <p>“{{ searchKey }}”共搜索到{{ total }}条信息</p>

      <ul>
        <li v-for="(item, index) in articleList" :key="index">
          <h4 v-html="replaceKey(searchKey, item.title)" @click="clickNews(item, clickTag)"></h4>
          <span>{{ item.addTime ? item.addTime.split(' ')[0] : '' }}</span>
        </li>
      </ul>

      <div class="show-more" @click="clickMore" v-show="!textShow">
        <span>展开更多</span>
        <van-icon name="arrow-down" />
      </div>

      <div class="show-more" v-show="textShow">暂无更多内容~</div>
    </div>
  </div>
</template>

<script>
import HeaderFrame from '@/components/Header';
import { configureParams } from '@/assets/js/configureParams';
import codes from '@/api/codes';
export default {
  name: 'index',
  components: {
    HeaderFrame,
  },
  computed: {
    searchKey() {
      return this.$route.query.searchKey;
    },
  },
  data() {
    return {
      articleList: [],
      total: 0,
      pageSize: 5,
      pageId: 1,
      textShow: false,
      clickTag: codes.ARTICLE, // 标记点击的是新闻文章
    };
  },
  watch: {
    searchKey(newVal) {
      if (newVal) {
        this.pageId = 1;
        this.articleList = [];
        this.initArticle();
      }
    },
  },
  mounted() {
    this.initArticle();
  },
  methods: {
    // 获取文章列表
    initArticle() {
      let replacement = {
        subjectId: codes.SUBJECT_ID,
      };
      this.$api
        .postSearchArticle(replacement, this.searchKey, this.pageId, this.pageSize)
        .then((data) => {
          this.articleList = this.articleList.concat(data.articleList);
          this.total = data.total;
          // this.textShow = false
          if (data.articleList.length < 5) {
            this.textShow = true;
          } else {
            this.textShow = false;
          }
        });
    },
    clickMore() {
      this.pageId++;
      this.initArticle();
    },
    // 关键词转红
    replaceKey(key, innerVal) {
      let titleStr = innerVal;
      if (!innerVal) {
        return '';
      }
      if (this.searchKey && this.searchKey.length > 0) {
        // 匹配关键字正则
        let replaceReg = new RegExp(this.searchKey, 'g');
        let replaceString =
          '<span class="search-text" style="color: #CD3434">' + this.searchKey + '</span>';
        // 开始替换
        titleStr = titleStr.replace(replaceReg, replaceString);
      }
      return titleStr;
    },

    // 点击新闻
    clickNews(articleData, clickTag) {
      let replacement = {
        subjectId: codes.SUBJECT_ID,
        articleId: articleData.id,
      };
      // 获取文章的上级菜单结构
      this.$api.getArticleUpMenus(replacement).then((data) => {
        this.$router.push({
          path: '/content',
          query: configureParams(data, articleData, clickTag),
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/css/common.scss';
.search {
  padding-top: calc-width(56vw);

  header {
    top: 0;
    position: absolute;
    z-index: 999;
    box-shadow: 0px calc-width(3vw) calc-width(10vw) rgba(0, 0, 0, 0.07);
  }

  .content {
    padding: 0 calc-width(19vw) calc-width(38vw);
    h1 {
      margin: calc-width(19vw) 0 calc-width(33vw);
      font-size: calc-width(16vw);
      font-family: SourceHanSansCN-Bold;
      font-weight: bold;
      color: rgba(17, 95, 173, 1);
    }

    p {
      font-size: calc-width(12vw);
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      color: rgba(17, 95, 173, 1);
      margin-bottom: calc-width(30vw);
    }

    ul {
      li {
        margin-bottom: calc-width(28vw);
        h4 {
          margin: 0 0 calc-width(14vw);
          font-size: calc-width(15vw);
          font-family: SourceHanSansCN-Light;
          font-weight: 300;
          color: rgba(51, 51, 51, 1);
        }

        span {
          font-size: calc-width(12vw);
          font-family: SourceHanSansCN-Normal;
          font-weight: 400;
          color: rgba(182, 181, 181, 1);
        }
      }
    }

    .show-more {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: calc-width(14vw);
      font-family: SourceHanSansCN-Normal;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      height: calc-width(25vw);
      line-height: calc-width(25vw);

      span {
        margin-right: calc-width(7vw);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/search/index.vue